import React from 'react';
import ContentCard from '../ContentCard';

const DataRetentionPeriods = () => {
  return <div className='left-align'>
    <ContentCard title="How long do we save your information?" 
      content= { <>
        <p>We will retain personal information we collect from you where we have an ongoing legitimate business need to do so (for example, to provide you with a service you have requested or to comply with applicable legal, tax or accounting requirements).</p>
        <p>When we have no ongoing legitimate business need to process your personal information, we will delete it.</p> 
        </>
      }
      />


  </div>;
};

export default DataRetentionPeriods;